@if (selectVehicleDetailsMethod) {
  <div>
    <section class="row" style="margin-top: 23px; padding-top: 0">
      <div class="col-2 radio">
        <label class="radio" (change)="onSelectCarDetailsMethod('vin')">
          <span class="spacer"><input type="radio" name="optionsRadios" [checked]="estimateWithVin"></span>
          <span class="spacer">{{''| i18n:'estimate-with-vin'}}</span>
        </label>
      </div>
      <!--    <span class="spacer"/>-->
      <div class="col-2 radio ">
        <label class="radio" (change)="onSelectCarDetailsMethod('novin')">
          <span class="spacer"><input type="radio" name="optionsRadios" value="20" [checked]="!estimateWithVin"></span>
          <span class="spacer">{{''| i18n:'estimate-without-vin'}}</span>
        </label>
      </div>
    </section>
  </div>
}


@if (selectVehicleDetailsMethod && !estimateWithVin) {
  <div>
    <form [formGroup]="form">
      <section class="row" style="margin-top: 23px; padding-top: 0">
        <label class="col-2">{{''|i18n:'first-registration'}}*:</label>
        <label class="col-2">{{''|i18n:'model-code'}}*:</label>
        <label class="col-2">{{''|i18n:'warranty-duration-option'}}*:</label>
      </section>
      <section class="row">
        <div class="col-2">
          <input class="col-12" type="date" formControlName="firstRegistrationDate">
          @if (form.get('firstRegistrationDate').dirty && !form.get('firstRegistrationDate').valid ) {
            <app-error-field [errorMessage]="invalidDateErrorMessage"
            ></app-error-field>
          }
        </div>
        <div class="col-2">
          <input class="col-12" type="string" formControlName="modelCode">
          @if (form.get('modelCode').dirty && !form.get('modelCode').valid ) {
            <app-error-field [errorMessage]="valueRequired"
            ></app-error-field>
          }
        </div>
        <div class="col-2">
          <select formControlName="duration" style="width: 300px;">
            <option value="24">{{'' | i18n: 'two-year-warranty'}}</option>
            <option value="36">{{'' | i18n: 'three-year-warranty'}}</option>
            <option value="48">{{'' | i18n: 'four-year-warranty'}}</option>
          </select>
          @if (form.get('duration').dirty && !form.get('duration').valid ) {
            <app-error-field [errorMessage]="valueRequired"
            ></app-error-field>
          }
        </div>
      </section>
    </form>
    <section style="margin-bottom: 23px;margin-top: 23px">
      <button style="height: 41px;width: 271px;" (click)="estimateWithNoVin()"
      [disabled]="!this.form.valid">{{''| i18n:'calculate'}}</button>
      <button (click)="clearFields()" style="height: 41px; width: 271px;">{{''| i18n:'clear'}}</button>
    </section>
  </div>
}


@if ((!selectVehicleDetailsMethod) || (selectVehicleDetailsMethod && estimateWithVin)) {
  <div>
    <form [formGroup]="form">
      <section class="row" style="margin-top: 23px; padding-top: 0">
        @if (displayOrderAndDeliveryDates) {
          <label class="col-2">{{''|i18n:'order-date'}}*:</label>
        }
        @if (displayOrderAndDeliveryDates) {
          <label class="col-2">{{''|i18n:'delivery-date'}}*:</label>
        }
        <label class="col-2">{{''|i18n:'today'}}:</label>
      </section>
      <section class="row">
        @if (displayOrderAndDeliveryDates) {
          <div class="col-2">
            <input class="col-12" type="date" formControlName="orderDate">
            @if (!form.get('orderDate').valid ) {
              <app-error-field [errorMessage]="invalidDateErrorMessage"
              ></app-error-field>
            }
          </div>
        }
        @if (displayOrderAndDeliveryDates) {
          <div class="col-2">
            <input class="col-12" type="date" formControlName="deliveryDate">
            @if (!form.get('deliveryDate').valid) {
              <app-error-field
              [errorMessage]="invalidDateErrorMessage"></app-error-field>
            }
          </div>
        }
        <div class="col-2">
          <input [disabled]="true" style="margin-left: 0" class="col-12" type="date" [value]="today">
        </div>
      </section>
    </form>
    <section>
      <div class="row">
        <label style="left: 13px;" class="col-2">{{''|i18n:'vin-number'}}:</label>
        @if (displayMileage) {
          <label class="col-2">{{''|i18n:'mileage'}}:</label>
        }
        <label class="col-2">{{''|i18n:'first-registration'}}:</label>
      </div>
      @if (configurableDate) {
        <div class="col">
          <app-estimation-input [displayMileage]="displayMileage"
          (estimationInput)="onFirstEstimationInput($event)"></app-estimation-input>
          <app-estimation-input [displayMileage]="displayMileage"
          (estimationInput)="onSecondEstimationInput($event)"></app-estimation-input>
          <app-estimation-input [displayMileage]="displayMileage"
          (estimationInput)="onThirdEstimationInput($event)"></app-estimation-input>
          <app-estimation-input [displayMileage]="displayMileage"
          (estimationInput)="onForthEstimationInput($event)"></app-estimation-input>
          <app-estimation-input [displayMileage]="displayMileage"
          (estimationInput)="onFifthEstimationInput($event)"></app-estimation-input>
        </div>
      }
    </section>
    <section style="margin-bottom: 23px;margin-top: 23px">
      <button style="height: 41px;width: 271px;" (click)="estimate()"
      [disabled]="!calculatable()">{{''| i18n:'calculate'}}</button>
      <button (click)="clearFields()" style="height: 41px; width: 271px;">{{''| i18n:'clear'}}</button>
    </section>
    <section style="height: 47px;">
    </section>
  </div>
}
<div>
  @if (estimationResults) {
    <section style="width: 90%;padding-bottom: 150px">
      <app-estimation-result style="width: 100%" [estimationResults]="estimationResults"
      [showVin]="estimateWithVin"></app-estimation-result>
    </section>
  }
</div>
